import Page from "@/lib/pages/Page";
import Markdown from "react-native-marked";
import {markdownStyle, markdownTheme} from "@/lib/globstyles";
import {Color} from "@/lib/styles";
import {ReactNode} from "react";
import {useQuery} from "@tanstack/react-query";
import {Doc} from "@/lib/types";
import {dataRetryPolicy, fetchBackend} from "@/lib/backend";
import ErrorMessage from "@/lib/components/ErrorMessage";
import SpinnerPage from "@/lib/pages/SpinnerPage";

type MarkdownPageProps = {
    slug: string;
    children?: ReactNode,
}

export default function MarkdownPage({slug, children}: MarkdownPageProps) {
    const {data, error, isLoading} = useQuery<Doc>({
        queryKey: ['docs', slug],
        queryFn: () => fetchBackend(`/docs/${slug.replace("-", "_")}`, "GET"),
        retry: dataRetryPolicy,
    });

    if (isLoading) {
        return <SpinnerPage/>
    }

    return (
        <Page scrollable={true}>
            {error && <ErrorMessage error={error}/>}
            {data && <Markdown
                value={data.text}
                styles={markdownStyle}
                theme={markdownTheme}
                flatListProps={{
                    scrollEnabled: false,
                    style: {
                        backgroundColor: Color.Background,
                    },
                }}
            />}
            {children}
        </Page>
    )
}